// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"5b4db825","155":"d5999a56","352":"ae2a931e","416":"7d8fdd60","538":"484ebf97","566":"da1d1fd8","676":"89ebd877","921":"275d3ebb","974":"fff477c8"}[chunkId] + ".chunk.js";
};